const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

let socket = null;
let reconnectTimer = null;
const listeners = new Set();

export function onRealtimeEvent(callback) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function connectRealtime() {
  const token = localStorage.getItem("token");
  if (!token || socket) return;

  const wsUrl = BACKEND_URL.replace(/^http/, "ws") + `/api/ws?token=${encodeURIComponent(token)}`;
  try {
    socket = new WebSocket(wsUrl);
  } catch (e) {
    socket = null;
    return;
  }

  socket.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);
      listeners.forEach((cb) => cb(data));
    } catch (e) {
      // ignore malformed payloads
    }
  };

  socket.onclose = () => {
    socket = null;
    if (localStorage.getItem("token")) {
      reconnectTimer = setTimeout(connectRealtime, 5000);
    }
  };

  socket.onerror = () => {
    if (socket) socket.close();
  };
}

export function disconnectRealtime() {
  clearTimeout(reconnectTimer);
  if (socket) {
    const s = socket;
    socket = null;
    s.onclose = null;
    s.close();
  }
}
